import FieldWithValidation from "./FieldWithValidation";
import {Controller} from "react-hook-form";
import {FormGroup, Input} from "reactstrap";
import React from "react";

const Selector = (props) => {
    const {control, name, rules = {}, defaultValue, errors, label, dispatch, items, optionTitle,
        optionKey, optionValue, optionLabel = 'name', isRequired = false} = props

    return (
        <FormGroup>
            <Controller
                control={control}
                name={name}
                defaultValue={defaultValue}
                rules={rules}
                render={(
                    {value, onBlur, name, ref, onChange},
                    {invalid}
                ) =>
                    <FieldWithValidation invalid={invalid} errors={errors} label={label}
                                         name={name} isRequired={isRequired}
                    >
                        <Input  type="select" id={name} invalid={invalid} name={name} onBlur={onBlur}
                                style={{border: invalid ? '1px solid #dc3545' : '0'}}
                                value={value}
                                onChange={e => {
                                    dispatch({type: 'setFormData', payload: e})
                                    onChange(e.target.value)
                                }}>
                            <option value={''} disabled>{optionTitle}</option>
                            {items.map(item =>
                                <option key={item[optionKey]} value={item[optionValue]}>
                                    {item[optionLabel]}
                                </option>)
                            }
                        </Input>
                    </FieldWithValidation>
                }
            />
        </FormGroup>
    )
}

export default Selector;